module.exports = require('./UserTabsComponent');